import { atom } from "recoil";

// ────────────────────────────────────────────
// Types
// ────────────────────────────────────────────

/** 기본 CSS 필터 (brightness, contrast 등) */
export interface BasicFilterSettings {
  brightness: number; // -100 ~ 100 (%)
  contrast: number; // -100 ~ 100 (%)
  saturate: number; //    0 ~ 200 (%)
  blur: number; //    0 ~  10 (px)
}

/** OpenCV 강도 기반 필터 */
export interface OpenCVStrengthFilter {
  strength: number; // 0 ~ 100 (%)
}

/** OpenCV 색공간 변환 필터 */
export interface OpenCVColorSpaceFilter {
  colorSpace: string; // "GRAY" | "HSV" | "LAB" | "BGR" | "XYZ" | "YCrCb" | "HLS" | "LUV" | "YUV" | ""
}

/** OpenCV 필터 모음 — 새 OpenCV 필터 추가 시 여기에 필드 추가 */
export interface OpenCVFilterSettings {
  equalizehist: OpenCVStrengthFilter;
  laplacian: OpenCVStrengthFilter;
  cvtcolor: OpenCVColorSpaceFilter;
  // 예: sharpen?: OpenCVStrengthFilter;
}

/** 전체 필터 설정 — 새 카테고리 추가 시 여기에 필드 추가 */
export interface FilterSettings extends BasicFilterSettings {
  opencvFilter: OpenCVFilterSettings;
  // 예: customFilter?: CustomFilterSettings;
}

export const filterDefault: FilterSettings = {
  // Basic
  brightness: 0,
  contrast: 0,
  saturate: 0,
  blur: 0,
  // OpenCV
  opencvFilter: {
    equalizehist: { strength: 0 },
    laplacian: { strength: 0 },
    cvtcolor: { colorSpace: "" },
  },
};

export const filterSettingState = atom<FilterSettings>({
  key: "filterSettingKey",
  default: filterDefault,
});

export const filterDisplayState = atom<"float" | "docked">({
  key: "filterDisplayKey",
  default: "float",
});
